import Cookies from 'js-cookie';
import CrossStorageClient from 'cross-storage/lib/client';

var whitelist = [/:\/\/(www\.)?(accounts\.labs\.|accounts\.staging\.|accounts\.)?(livechatinc\.|livechat\.)com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?((labs\.)|(staging\.))?helpdesk\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?((labs\.)|(staging\.))?livechat\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?(my\.labs\.|my\.staging\.|my\.)livechatinc\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?((labs\.)|(staging\.))?knowledgebase\.ai(\/.*)?(\?.*)?$/, /:\/\/(www\.)?(app\.staging\.|app\.)knowledgebase\.ai(\/.*)?(\?.*)?$/, /:\/\/(www\.)?((labs\.)|(staging\.))?chatbot\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?((labs\.)|(staging\.))?openwidget\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?(platform\.)?((labs\.)|(staging\.))?text\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?(marketplace-agentapp\.)((labs\.)|(staging\.))?livechatinc\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?(marketplace\.)((labs\.)|(staging\.))?helpdesk\.com(\/.*)?(\?.*)?$/, /:\/\/(www\.)?direct\.lc\.chat(\/.*)?(\?.*)?$/];

// temporary setting debugging flag to true
// after testing it will be removed from production
window.debuggingEnabled = true;

// window.debuggingEnabled = document.location.href.includes('labs') || document.location.href.includes('staging') || document.location.href.includes('development');

var debugLog = function debugLog() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    if (window.debuggingEnabled) {
        var _console;

        (_console = console).log.apply(_console, ["[debug logs from @livechat/store-metrics]"].concat(args));
    }
};

var DAYS_14 = 1209600000; // ms
var DAYS_120 = 10368000000; // ms

var UTMs = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

var TTLs = {
  utm: DAYS_14,
  referrer: DAYS_14,
  landing_page: DAYS_14,
  discount: DAYS_14,
  partner_id: DAYS_120,
  promocode: DAYS_120,
  sscid: DAYS_120

  /**
   * Converts hostname to wildcard domain
   *
   * Examples:
   * www.livechat.com -> .livechat.com
   * partners.labs.livechat.com -> partners.labs.livechat.com
   */
};var hostnameToWildcard = function hostnameToWildcard(hostname) {
  var hostParts = hostname.split('.');
  if (hostParts.includes('partners')) {
    return '.' + hostParts.slice(hostParts.indexOf('partners')).join('.');
  }
  return '.' + (hostParts.length > 2 ? hostParts.slice(1).join('.') : hostParts.join('.'));
};

/**
 * Gets cross-storage hub URL for given product hostname
 */
var getStorageUrl = function getStorageUrl(host) {
  return 'https://accounts.' + (host.includes('labs') ? 'labs.' : '') + 'livechat.com/static/hub.html';
};

/**
 * Converts hostname to product name
 *
 * Examples:
 * www.helpdesk.com -> helpdesk
 * livechat.com -> livechat
 */
var hostnameToProduct = function hostnameToProduct(hostname) {
  var hostParts = hostname.split('.');
  if (hostParts.length > 1) {
    if (hostParts.includes('partners')) {
      // mapping to the expected value https://github.com/livechat/accounts.livechatinc.com/blob/labs/src/constants/tracking.ts
      return 'partnerprogram';
    }
    return hostParts[hostParts.length - 2];
  }
};

// Stores marketing params as cookies
// Returns params set while executing
function index () {
  var out = {};

  var location = new window.URL(document.location.href);
  var product = hostnameToProduct(location.hostname);
  var storageUrl = getStorageUrl(location.hostname);

  var inSession = Boolean(Cookies.get('metrics_session'));

  // Handle UTM params
  var foundUtms = UTMs.filter(function (utm) {
    return location.searchParams.has(utm);
  });
  if (foundUtms.length) {
    // Prevent UTM params overlapping:
    // when any param is present in query
    // overwrite all saved previously
    out.utm = {};

    foundUtms.forEach(function (utm) {
      out.utm[utm] = location.searchParams.get(utm);
    });
  }

  // Check and store the referrer, excluding internal referrers
  if (location.searchParams.has('referrer')) {
    out.referrer = location.searchParams.get('referrer');
  } else {
    var referrer = document.referrer ? new URL(document.referrer) : null;
    if (referrer && hostnameToWildcard(referrer.hostname) !== hostnameToWildcard(location.hostname)) {
      out.referrer = referrer.href;
    }
  }

  // Store landing page
  if (location.searchParams.has('landing_page')) {
    out.landing_page = location.searchParams.get('landing_page');
  } else if (!inSession) {
    out.landing_page = location.origin + location.pathname;
  }

  // Store discount
  if (location.searchParams.has('discount')) {
    out.discount = location.searchParams.get('discount');
  }

  // Store affiliation
  if (location.searchParams.has('a')) {
    out.partner_id = location.searchParams.get('a');
  }

  if (location.searchParams.has('partner_id')) {
    out.partner_id = location.searchParams.get('partner_id');
  }

  // resetting conditions defined in PP-11161
  // https://livechatinc.atlassian.net/browse/PP-11161
  var isSourceOrReferrerOnWhitelist = whitelist.some(function (regex) {
    if (out.referrer) return regex.test(out.referrer);
    if (out.utm && out.utm.utm_source) return regex.test('https://' + out.utm.utm_source);
    return false;
  });

  var isDirectVisit = !out.referrer;
  var hasUtmSourceOrMedium = !!(out.utm && (out.utm.utm_source || out.utm.utm_medium));
  var hasPartnerId = !!out.partner_id;

  var shouldResetPartnerId = true;

  if (hasPartnerId || isSourceOrReferrerOnWhitelist && !hasPartnerId || isDirectVisit && !hasUtmSourceOrMedium && !hasPartnerId) {
    shouldResetPartnerId = false;
  }

  if (shouldResetPartnerId) {
    out.partner_id = undefined;
  }

  debugLog('shouldResetPartnerId', shouldResetPartnerId);

  // Store promocode (deprecated)
  // TODO: Add logging
  if (location.searchParams.has('partner')) {
    out.promocode = location.searchParams.get('partner');
  }

  // http://shareasale.com/itp/lead.htm#_Toc522268050
  if (location.searchParams.has('sscid')) {
    out.sscid = location.searchParams.get('sscid');
  }

  // Send params to Accounts Client Store
  var paramsToSave = Object.keys(out);

  if (paramsToSave.length) {
    // Initiate storage only when there is something to save
    var storage = new CrossStorageClient(storageUrl);

    var storagePromise = storage.onConnect();
    paramsToSave.forEach(function (param) {
      storagePromise.then(function () {
        return storage.set(product + ':' + param, out[param], TTLs[param]);
      });
    });

    // eslint-disable-next-line no-console
    storagePromise.catch(function (err) {
      return console.error(err);
    });

    // Prevent some params overwriting in current 'session'
    Cookies.set('metrics_session', 'true', {
      domain: hostnameToWildcard(location.hostname),
      samesite: 'none',
      secure: true,
      expires: 14
    });
  }

  return out;
}

export default index;
